(() => {
  'use strict';
  const root = document.body.dataset.scRoot || '/';
  const products = new WeakMap();
  let cartBusy = false;
  let cartNoteDraft = null;
  let toastTimer;
  let opener;
  const endpoint = path => root.replace(/\/$/, '') + '/' + path;
  const money = cents => new Intl.NumberFormat(document.body.dataset.scLocale || 'en', {
    style: 'currency', currency: document.body.dataset.scCurrency || 'USD'
  }).format(cents / 100);
  const message = (node, text, error = false) => {
    if (!node) return;
    node.textContent = text;
    node.classList.toggle('sc-error', error);
  };
  function toast(text) {
    const node = document.getElementById('sc-toast');
    if (!node) return;
    message(node, text); node.classList.add('visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => node.classList.remove('visible'), 3000);
  }
  function openDialog(id, trigger) {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    document.querySelectorAll('dialog[open]').forEach(other => other.close());
    opener = trigger;
    dialog.showModal();
    recommendationRails(dialog);
    const search = dialog.querySelector('input[type=search]');
    if (search) search.focus();
  }
  const initializedRails = new WeakSet();
  function recommendationRails(scope = document) {
    scope.querySelectorAll('.sc-cart-recommendations').forEach(section => {
      const rail = section.querySelector('.sc-cart-recommendation-rail');
      const update = () => section.querySelectorAll('[data-sc-rail-step]').forEach(button => {
        button.disabled = Number(button.dataset.scRailStep) < 0 ? rail.scrollLeft <= 1 : rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
      });
      if (!initializedRails.has(rail)) { rail.addEventListener('scroll', update, {passive:true}); initializedRails.add(rail); }
      update();
    });
  }
  function header() {
    const element = document.querySelector('[data-sc-header]');
    if (!element) return;
    document.body.classList.toggle('header-condensed', window.scrollY > Number(element.dataset.scThreshold || 90));
    document.documentElement.style.setProperty('--sc-header-offset', element.getBoundingClientRect().height + 'px');
  }
  let headerFrame;
  window.addEventListener('scroll', () => {
    if (headerFrame) return;
    headerFrame = requestAnimationFrame(() => { headerFrame = null; header(); });
  }, {passive: true});
  window.addEventListener('resize', () => { header(); recommendationRails(); });
  function media(section, id) {
    if (!id || !section.querySelector(`[data-sc-media-id="${Number(id)}"]`)) return;
    section.querySelectorAll('[data-sc-media-id]').forEach(panel => {
      const active = Number(panel.dataset.scMediaId) === Number(id);
      panel.classList.toggle('is-active', active);
      if (!active) panel.querySelectorAll('video').forEach(video => video.pause());
    });
    section.querySelectorAll('[data-sc-show-media]').forEach(button => {
      button.setAttribute('aria-pressed', String(Number(button.dataset.scShowMedia) === Number(id)));
    });
  }
  class Product {
    constructor(section) {
      this.section = section;
      this.data = JSON.parse(section.querySelector('[data-sc-product-json]').textContent);
      this.form = section.querySelector('.sc-product-form');
      this.select = this.form.querySelector('[data-sc-variant-select]');
      this.button = this.form.querySelector('[data-sc-buy-button]');
      this.quantity = this.form.elements.namedItem('quantity');
      // The Liquid-selected variant is authoritative, including an unavailable deep link.
      const chosen = this.data.variants.find(v => v.id === this.data.selectedId);
      this.options = chosen ? [...chosen.options] : [];
      this.form.querySelector('[data-sc-custom-options]').hidden = false;
      this.select.hidden = true;
      this.update(chosen, false);
    }
    choose(index, value) {
      this.options[index] = value;
      this.update(this.data.variants.find(v => v.options.every((option, i) => option === this.options[i])), true);
    }
    update(variant, updateUrl) {
      this.current = variant || null;
      const buyable = !!variant?.buyable;
      this.select.value = variant ? String(variant.id) : '';
      this.select.disabled = !buyable;
      this.button.disabled = !buyable;
      const price = this.section.querySelector('[data-sc-price]');
      if (variant) price.textContent = money(variant.price);
      this.form.querySelectorAll('[data-sc-option-index]').forEach(button => {
        const index = Number(button.dataset.scOptionIndex), value = button.dataset.scOptionValue;
        button.setAttribute('aria-pressed', String(this.options[index] === value));
        // Global reachability avoids trapping shoppers between otherwise valid combinations.
        button.disabled = !this.data.variants.some(v => v.buyable && v.options[index] === value);
      });
      if (variant?.stock != null) this.quantity.max = String(Math.max(1, variant.stock));
      else this.quantity.removeAttribute('max');
      const payment = this.form.querySelector('[data-sc-payment]');
      if (payment) payment.hidden = !buyable;
      this.priceButton();
      if (variant?.mediaId) media(this.section, variant.mediaId);
      if (updateUrl) {
        const url = new URL(window.location.href);
        if (variant) url.searchParams.set('variant', variant.id);
        else url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
        this.select.dispatchEvent(new Event('change', {bubbles: true}));
      }
      message(this.form.querySelector('[data-sc-form-status]'), variant ? '' : 'This combination is unavailable. Please choose another option.', !variant);
    }
    priceButton() {
      this.button.textContent = this.current?.buyable ? `Add to bag — ${money(this.current.price * Number(this.quantity.value || 1))}` : (this.current ? 'Sold out' : 'Unavailable');
    }
  }
  function init(scope = document) {
    const sections = [...scope.querySelectorAll('[data-sc-product]')];
    if (scope.matches?.('[data-sc-product]')) sections.push(scope);
    sections.forEach(section => {
      if (products.has(section)) return;
      try { products.set(section, new Product(section)); }
      catch (error) {
        // Leave the native variant selector/form usable if enhancement cannot initialize.
        const select = section.querySelector('[data-sc-variant-select]');
        if (select) select.hidden = false;
        const custom = section.querySelector('[data-sc-custom-options]');
        if (custom) custom.hidden = true;
        console.error('Product enhancement could not initialize', error);
      }
    });
    scope.querySelectorAll('dialog').forEach(dialog => {
      if (dialog.dataset.scInitialized) return;
      dialog.dataset.scInitialized = 'true';
      dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
    });
    recommendationRails(scope);
    scope.querySelectorAll('[data-sc-country]').forEach(country => {
      if (country.dataset.scReady) return;
      country.dataset.scReady = 'true';
      country.value = country.dataset.default || country.value;
      const wrap = country.closest('.sc-address-fields');
      const province = wrap.querySelector('[data-sc-province]');
      const update = initial => {
        let values = [];
        try { values = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch { /* Keep province hidden for countries without data. */ }
        province.replaceChildren(...values.map(([value, label]) => { const option = document.createElement('option'); option.value = value; option.textContent = label; return option; }));
        if (initial) province.value = province.dataset.default || province.value;
        province.closest('[data-sc-province-wrap]').hidden = !values.length;
        province.disabled = !values.length;
      };
      country.addEventListener('change', () => update(false)); update(true);
    });
    header();
  }
  const controllers = new WeakMap();
  function pending(form, enabled) {
    if (enabled) {
      const state = [...form.elements].filter(el => el.matches('button,input,select,textarea')).map(el => [el, el.disabled]);
      controllers.set(form, state); state.forEach(([el]) => { el.disabled = true; });
      form.classList.add('sc-form-pending'); form.setAttribute('aria-busy', 'true');
    } else {
      (controllers.get(form) || []).forEach(([el, disabled]) => { if (el.isConnected) el.disabled = disabled; });
      controllers.delete(form); form.classList.remove('sc-form-pending'); form.removeAttribute('aria-busy');
    }
  }
  async function jsonResponse(response) {
    let data;
    try { data = await response.json(); }
    catch { throw new Error('The store response could not be read. Please refresh your bag and try again.'); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'The request could not be completed. Please refresh your bag and try again.');
    return data;
  }
  async function readCart() { return jsonResponse(await fetch(endpoint('cart.js'), {headers: {Accept: 'application/json'}})); }
  async function refreshCart() {
    const active = document.activeElement;
    const focusLine = active?.closest('[data-sc-line-key]');
    const focusKey = focusLine?.dataset.scLineKey;
    const focusStep = active?.getAttribute('data-sc-cart-step');
    const noteWasOpen = [...document.querySelectorAll('.sc-cart-notes')].some(details => details.open);
    const cart = await readCart();
    document.querySelectorAll('[data-sc-cart-count]').forEach(el => { el.textContent = `(${cart.item_count})`; });
    document.querySelectorAll('[data-sc-cart-open]').forEach(el => { el.setAttribute('aria-label', `Open shopping bag, ${cart.item_count} items`); });
    const page = document.querySelector('[data-sc-cart-page]');
    const ids = ['sc-cart-drawer']; if (page) ids.push(page.dataset.scSectionId);
    const url = new URL(window.location.href); url.searchParams.set('sections', ids.join(','));
    // HTML resource routes must keep the default Accept header. Requesting
    // application/json negotiates product/cart JSON instead of section markup.
    const rendered = await jsonResponse(await fetch(url));
    const parser = new DOMParser();
    const replacements = [];
    for (const id of ids) {
      if (typeof rendered[id] !== 'string') continue;
      const html = parser.parseFromString(rendered[id], 'text/html');
      if (id === 'sc-cart-drawer') {
        const target = document.querySelector('#sc-cart-dialog [data-sc-cart-contents]');
        const next = html.querySelector('[data-sc-cart-contents]');
        if (target && next) replacements.push([target, next]);
      } else {
        const next = html.querySelector('[data-sc-cart-page]');
        if (page && next) replacements.push([page, next]);
      }
    }
    if (replacements.length !== ids.length) throw new Error('Your bag changed, but its display could not refresh. Open the full bag to review it before checkout.');
    replacements.forEach(([target, next]) => target.replaceWith(next));
    recommendationRails();
    document.querySelectorAll('[data-sc-cart-note]').forEach(note => { if (cartNoteDraft !== null) note.value = cartNoteDraft; });
    if (noteWasOpen) document.querySelectorAll('.sc-cart-notes').forEach(details => { details.open = true; });
    if (active && !active.isConnected) {
      const row = [...document.querySelectorAll('[data-sc-line-key]')].find(line => line.dataset.scLineKey === focusKey && !!line.closest('dialog')?.open === !!document.querySelector('#sc-cart-dialog[open]'));
      let nextFocus = null;
      if (row) {
        if (focusStep !== null) nextFocus = [...row.querySelectorAll('[data-sc-cart-step]')].find(button => button.dataset.scCartStep === focusStep && !button.disabled);
        if (!nextFocus && active.matches('[data-sc-remove]')) nextFocus = row.querySelector('[data-sc-remove]');
        if (!nextFocus) nextFocus = row.querySelector('[data-sc-line-quantity]');
      }
      if (!nextFocus && document.querySelector('#sc-cart-dialog[open]')) nextFocus = document.getElementById('sc-cart-heading');
      if (!nextFocus && page) nextFocus = document.querySelector('[data-sc-cart-page] h1');
      if (nextFocus) { if (nextFocus.tagName === 'H1') nextFocus.tabIndex = -1; nextFocus.focus({preventScroll:true}); }
    }
    document.querySelectorAll('[data-sc-cart-status]').forEach(node => message(node, ''));
    return cart;
  }
  function cartError(text) {
    document.querySelectorAll('[data-sc-cart-status]').forEach(node => message(node, text, true));
  }
  async function add(form, submitter) {
    const status = form.querySelector('[data-sc-form-status]');
    if (cartBusy) { message(status, 'Please wait for the current bag update to finish.', true); return; }
    if (!form.reportValidity()) return;
    const controller = form.classList.contains('sc-product-form') ? products.get(form.closest('[data-sc-product]')) : null;
    const field = form.elements.namedItem('id');
    const selected = field?.tagName === 'SELECT' ? field.selectedOptions[0] : field;
    const buyable = controller ? !!controller.current?.buyable : selected?.dataset.scBuyable === 'true';
    if (!buyable || !field?.value) { message(status, 'This item or selection is unavailable.', true); return; }
    const data = new FormData(form);
    const id = Number(data.get('id')), quantity = Number(data.get('quantity') || 1);
    if (!Number.isSafeInteger(id) || !Number.isSafeInteger(quantity) || quantity < 1) { message(status, 'Choose a valid item and quantity.', true); return; }
    const rawStock = selected?.dataset.scStock;
    const stock = controller ? controller.current.stock : rawStock === '' || rawStock == null ? null : Number(rawStock);
    cartBusy = true; pending(form, true); message(status, 'Adding to your bag…');
    let accepted = false;
    try {
      if (stock != null) {
        const cart = await readCart();
        const held = cart.items.filter(item => Number(item.variant_id) === id).reduce((total, item) => total + item.quantity, 0);
        if (held + quantity > stock) throw new Error('The requested quantity exceeds the stock available for this selection. Please reduce the quantity or refresh the product page.');
      }
      await jsonResponse(await fetch(endpoint('cart/add.js'), {method: 'POST', headers: {Accept: 'application/json'}, body: data}));
      accepted = true;
      await refreshCart();
      message(status, 'Added to your bag.'); toast('Added to your bag');
      if (document.body.dataset.scCartMode === 'drawer') openDialog('sc-cart-dialog', submitter);
      else window.location.assign(endpoint('cart'));
    } catch (error) {
      if (!accepted) { try { await refreshCart(); } catch { /* Original request error remains primary. */ } }
      const text = accepted ? 'The item was added, but the bag display could not refresh. Open the full bag to review it before checkout.' : error.message;
      message(status, text, true); cartError(text);
    } finally { pending(form, false); cartBusy = false; }
  }
  async function changeLine(key, quantity, trigger) {
    if (cartBusy) { cartError('Please wait for the current bag update to finish.'); return; }
    if (!Number.isSafeInteger(quantity) || quantity < 0) { cartError('Enter a valid quantity.'); return; }
    cartBusy = true;
    const form = trigger.closest('form'); if (form) pending(form, true);
    try {
      await jsonResponse(await fetch(endpoint('cart/change.js'), {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: key, quantity})}));
      await refreshCart();
    } catch (error) {
      try { await refreshCart(); } catch { /* Preserve the mutation error. */ }
      cartError(error.message);
    } finally { if (form) pending(form, false); cartBusy = false; }
  }
  async function updateCart(form) {
    if (cartBusy) { cartError('Please wait for the current bag update to finish.'); return; }
    if (!form.reportValidity()) return;
    const changes = [...form.querySelectorAll('[data-sc-line-quantity]')].map(el => ({id: el.dataset.scKey, quantity: Number(el.value)}));
    const note = form.elements.namedItem('note')?.value;
    cartBusy = true; pending(form, true);
    try {
      // change.js validates line inventory; update.js is only used to save the note.
      for (const change of changes) await jsonResponse(await fetch(endpoint('cart/change.js'), {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(change)}));
      if (note != null) {
        await jsonResponse(await fetch(endpoint('cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({note})}));
        if (cartNoteDraft === note) cartNoteDraft = null;
      }
      await refreshCart();
    } catch (error) { try { await refreshCart(); } catch { /* Preserve error. */ } cartError(error.message); }
    finally { pending(form, false); cartBusy = false; }
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-sc-open]');
    if (open) { event.preventDefault(); openDialog(open.dataset.scOpen, open); }
    const cart = event.target.closest('[data-sc-cart-open]');
    if (cart && document.body.dataset.scCartMode === 'drawer') { event.preventDefault(); openDialog('sc-cart-dialog', cart); }
    const close = event.target.closest('[data-sc-close]');
    if (close) close.closest('dialog')?.close();
    const mediaButton = event.target.closest('[data-sc-show-media]');
    if (mediaButton) media(mediaButton.closest('[data-sc-product]'), mediaButton.dataset.scShowMedia);
    const option = event.target.closest('[data-sc-option-index]');
    if (option && !option.disabled) products.get(option.closest('[data-sc-product]'))?.choose(Number(option.dataset.scOptionIndex), option.dataset.scOptionValue);
    const quantity = event.target.closest('[data-sc-quantity]');
    if (quantity) {
      const form = quantity.closest('form'), input = form.elements.namedItem('quantity');
      const next = Number(input.value || 1) + Number(quantity.dataset.scQuantity);
      input.value = String(Math.max(1, input.max ? Math.min(next, Number(input.max)) : next));
      products.get(form.closest('[data-sc-product]'))?.priceButton();
    }
    const cartStep = event.target.closest('[data-sc-cart-step]');
    if (cartStep && !cartStep.disabled) {
      const input = cartStep.closest('[data-sc-line-key]').querySelector('[data-sc-line-quantity]');
      const next = Math.max(0, Number(input.value) + Number(cartStep.dataset.scCartStep));
      if (cartStep.dataset.scCartStep === '1' && input.max !== '' && next > Number(input.max)) cartError('The requested quantity exceeds the available stock.');
      else changeLine(input.dataset.scKey, next, cartStep);
    }
    const railStep = event.target.closest('[data-sc-rail-step]');
    if (railStep) {
      const rail = railStep.closest('.sc-cart-recommendations').querySelector('.sc-cart-recommendation-rail');
      rail.scrollBy({left: Number(railStep.dataset.scRailStep) * rail.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    const remove = event.target.closest('[data-sc-remove]');
    if (remove) { event.preventDefault(); changeLine(remove.dataset.scRemove, 0, remove); }
    if (event.target.tagName === 'DIALOG') {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-sc-cart-note]')) cartNoteDraft = event.target.value;
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('[data-sc-line-quantity]')) changeLine(input.dataset.scKey, Number(input.value), input);
    if (input.matches('.sc-product-form [name=quantity]')) products.get(input.closest('[data-sc-product]'))?.priceButton();
    if (input.matches('[data-sc-sort]')) input.form.requestSubmit();
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('[data-sc-add-form]')) { event.preventDefault(); add(form, event.submitter); }
    if (form.matches('[data-sc-cart-form]')) {
      if (event.submitter?.name === 'checkout') { if (cartBusy) { event.preventDefault(); cartError('Please wait for the bag update to finish.'); } return; }
      event.preventDefault(); updateCart(form);
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('video').forEach(video => video.pause());
  });
  init();
})();
